module.exports = __webpack_public_path__ + "images/external_images/svg/components/request-quote-dark-icon.svg";